import React from 'react';
import { BookOpen } from 'lucide-react';

const GLOSSAR_BEGRIFFE = [
  {
    begriff: 'Wertminderung',
    definition: 'Der Betrag, um den ein Fahrzeug trotz fachgerechter Reparatur aufgrund des Unfalls an Marktwert verliert.'
  },
  {
    begriff: 'Nutzungsausfall',
    definition: 'Der finanzielle Ausgleich für die Zeit, in der ein Fahrzeug unfallbedingt nicht genutzt werden kann.'
  },
  {
    begriff: 'Wiederbeschaffungswert',
    definition: 'Der Betrag, der erforderlich ist, um ein gleichwertiges Fahrzeug vor dem Unfall zu beschaffen.'
  }
];

export const MiniGlossar = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Glossar
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Wichtige Begriffe kurz erklärt
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {GLOSSAR_BEGRIFFE.map((item, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-3xl p-8 hover:border-brand-green/30 hover:shadow-xl transition-all duration-300">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-brand-green/10 rounded-xl flex items-center justify-center border border-brand-green/15">
                  <BookOpen className="w-5 h-5 text-brand-green" />
                </div>
                <h3 className="text-lg font-bold text-gray-900">{item.begriff}</h3>
              </div>
              <p className="text-gray-600 leading-relaxed text-[15px]">{item.definition}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
